import axios from 'axios';

function resolveApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_URL;
  if (configured) return configured;

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'df-scraper.exe.im') {
      return 'https://df-scraper-api.exe.im';
    }
  }

  return import.meta.env.PROD
    ? 'https://df-scraper-worker.edmusic-myd.workers.dev'
    : '';
}

export const API_BASE_URL = resolveApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    // Only add JWT token if Authorization header is not already set
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check error code to distinguish between token issues and business logic errors
      const errorCode = error.response?.data?.error?.code;
      
      // Only redirect for token-related errors, not business logic errors like wrong password
      const isTokenError = errorCode === 'INVALID_TOKEN' || errorCode === 'TOKEN_EXPIRED';
      const isLoginRequest = error.config?.url?.includes('/auth/login');
      const isReadRequest = error.config?.url?.includes('/api/v1/read');
      const isOnLoginPage = window.location.pathname === '/login';
      
      // Only logout and redirect for token errors (not for INVALID_CREDENTIALS like wrong password)
      if (isTokenError && !isLoginRequest && !isReadRequest && !isOnLoginPage) {
        console.error('Token invalid/expired - redirecting to login', error.config?.url);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
